import React, { useEffect } from 'react';

import classNames from 'classnames';

import { useSortSimilarAtLastPosition } from '../../../hooks/useSortSimilarAtLastPosition';
import { useHawkWidgetContext } from '../../GenericComponents/HawkWidget/HawkWidgetContext';
import { AmazonPrimeShipping } from '../../GenericComponents/Shipping';
import itemStyles from '../Main/styles/review-items.css';

const ReviewRetailItems: React.FC = () => {
  const {
    genericSharedComponents: { Button, GridItems, DealImage, MainPrice },
    dealData,
    sortSimilarAtLastPosition,
    loading,
    showShipping,
  } = useHawkWidgetContext();

  useEffect(() => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useSortSimilarAtLastPosition(dealData, sortSimilarAtLastPosition);
  }, [loading]);

  return (
    <GridItems
      className={{
        gridItems: itemStyles['grid-items'],
        gridItemMain: classNames(itemStyles['grid-item-main']),
        gridItemBlock: classNames(itemStyles['grid-item-block']),
        gridItem: classNames(itemStyles['grid-item']),
      }}
      widgetName="review"
    >
      {(deal): JSX.Element => {
        return (
          <>
            <DealImage key="image" deal={deal} />
            <React.Fragment key="merchant">
              <>
                <DealImage deal={deal} priority={['merchant']} />
                {showShipping && deal?.shipping?.url && deal?.shipping?.prime && (
                  <AmazonPrimeShipping deal={deal} showLink={false} />
                )}
              </>
            </React.Fragment>
            <React.Fragment key="priceLink">
              <>
                <MainPrice deal={deal} className="container" />
                <Button deal={deal} />
              </>
            </React.Fragment>
          </>
        );
      }}
    </GridItems>
  );
};

export default ReviewRetailItems;
